var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlayBtnNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.666656 13.1619C0.666656 14.7105 2.35088 15.6716 3.68412 14.8838L12.4194 9.72202C13.7295 8.94789 13.7295 7.05243 12.4194 6.27831L3.68412 1.11654C2.35089 0.328722 0.666656 1.28979 0.666656 2.83839V13.1619Z",
    fill: "#BA8D5B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayBtnNew);
export default __webpack_public_path__ + "static/media/play-btn-new.1f9a58d70038bfde1acde3cd097e2126.svg";
export { ForwardRef as ReactComponent };